export default __webpack_public_path__ + "static/media/video-training.529acef0.png";